import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

export interface RangeType {
  min: number;
  max: number;
}
@Component({
    selector: 'summary-ref',
    templateUrl: './summary-ref.component.html',
    styleUrls: ['./summary-ref.component.scss'],
    standalone: false
})
//EaSubscriptionSummaryREFComponent
export class SummaryREFComponent implements OnInit {
  isMinValueInit = true;
  isMaxValueInit = true;
  thumbLabel = true;
  @Input() minValue: number = 30;
  @Input() maxValue: number = 80;
  @Input() minColor: ThemePalette = 'primary';
  @Input() maxColor: ThemePalette = 'primary';
  @Input() title: string = 'Part de fonds euros conseillée';
  @Input() showRuler = false;

  @Input() formatLabel = v => v + '%';

  @Output() output = new EventEmitter<RangeType>();

  maxConf = 100;

  @Input()
  set max(m: number) {
    this.maxConf = parseInt(m.toString(), 10);
  }
  get max(): number {
    return this.maxConf;
  }

  minConf = 0;

  @Input()
  set min(m: number) {
    this.minConf = parseInt(m.toString(), 10);
  }
  get min(): number {
    return this.minConf;
  }

  @Input()
  set value(v: { min: number; max: number }) {
    this.minValue = v.min;
    this.maxValue = v.max;
  }

  get value(): { min: number; max: number } {
    return { min: this.minValue, max: this.maxValue };
  }

  get rulerArray(): number[] {
    return [...Array(this.max - this.min).keys()].map(i => i + this.min);
  }

  ngOnInit(): void {
    if (!this.minValue) {
      this.minValue = this.min;
    }
    if (!this.maxValue) {
      this.maxValue = this.max;
    }
    this.isMinValueInit = this.minValue === this.min;
    this.isMaxValueInit = this.maxValue === this.max;
    this.output.emit({ min: this.minValue, max: this.maxValue });
  }
  keepIt(d) {
    this.maxValue = this.maxValue;
  }
  valueChange(): void {
    this.output.emit({ min: this.minValue, max: this.maxValue });
  }

  minValueInput(value: number): void {
    this.isMinValueInit = value === this.min;
    if (value >= this.maxValue) {
      this.minValue = this.maxValue;
    }
  }

  maxValueInput(value: number): void {
    this.isMaxValueInit = value === this.max;
    if (value <= this.minValue) {
      this.maxValue = this.minValue;
    }
  }
}
